import './footer.css'
export default function Footer() {
    return(
        <div className="footerbox">
            <p>© 2025 MAHOGANY</p>
        </div>
    )
}